<section class="container-fluid">

    <header #header class="container header-nav">
        <div class="row">
            <div class="col brand ">
                <div class="position-relative">

                    <div class="brand-wrapper">
                        <button class="navbar-toggler btn btn-link"
                                (click)="showNav = !showNav"
                                type="button">
                            <i class="bi bi-list"></i>
                        </button>
                        <a class="navbar-brand" href="/">
                            <svg width="115" height="21" viewBox="0 0 115 21" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M2.41402 0.0463867C2.89146 0.0463867 3.35819 0.188113 3.75517 0.453644C4.15215 0.719175 4.46156 1.09659 4.64427 1.53815C4.82699 1.97971 4.87479 2.46559 4.78165 2.93435C4.6885 3.40311 4.45859 3.8337 4.12098 4.17166C3.78338 4.50961 3.35324 4.73976 2.88497 4.83301C2.41669 4.92625 1.93132 4.87839 1.49021 4.69549C1.04911 4.51259 0.67209 4.20286 0.406834 3.80546C0.141579 3.40807 0 2.94086 0 2.46291C0 1.82201 0.254334 1.20736 0.707049 0.754172C1.15977 0.300985 1.77378 0.0463867 2.41402 0.0463867ZM14.8423 7.89401H14.48C13.5599 7.89437 12.6776 8.26041 12.027 8.91169C11.3764 9.56298 11.0108 10.4462 11.0104 11.3673V11.669C11.0104 12.5901 11.3759 13.4736 12.0266 14.1249C12.6773 14.7763 13.5598 15.1422 14.48 15.1422H14.8409C15.2966 15.1422 15.7477 15.0524 16.1687 14.8778C16.5897 14.7033 16.9721 14.4475 17.2943 14.1249C17.6165 13.8024 17.8721 13.4195 18.0464 12.9981C18.2208 12.5767 18.3106 12.1251 18.3106 11.669V11.3673C18.3091 10.4469 17.943 9.56472 17.2925 8.91432C16.642 8.26391 15.7603 7.89842 14.8409 7.89807L14.8423 7.89401ZM93.0653 11.669C93.0651 12.125 93.1547 12.5766 93.3289 12.998C93.5031 13.4194 93.7586 13.8023 94.0806 14.1249C94.4027 14.4474 94.7851 14.7033 95.206 14.8778C95.6269 15.0524 96.078 15.1422 96.5336 15.1422H96.8958C97.816 15.1422 98.6985 14.7763 99.3492 14.1249C99.9999 13.4736 100.365 12.5901 100.365 11.669V11.577C100.365 11.577 100.365 11.4173 100.365 11.3673C100.365 10.4461 99.9999 9.56266 99.3492 8.9113C98.6985 8.25994 97.816 7.89401 96.8958 7.89401H96.5336C95.6136 7.89437 94.7314 8.26046 94.081 8.91178C93.4306 9.5631 93.0653 10.4463 93.0653 11.3673V11.669ZM52.4906 2.46291V20.5814H46.457V2.46291H52.4906ZM70.1173 4.76308L70.1578 4.72654C73.8316 1.47925 79.4287 1.39672 82.9348 4.9065C84.543 6.51315 85.5101 8.65224 85.6543 10.9221L85.6746 14.5753V20.5814H79.6409V11.0398C79.5961 10.2234 79.2515 9.45234 78.6731 8.87496C77.3782 7.57875 74.9886 7.43939 73.8599 8.75454C73.2866 9.44374 72.9851 10.3192 73.0125 11.2157L73.0044 12.3239V20.5774H66.9707V11.0385C66.928 10.2196 66.5831 9.4457 66.0029 8.86684C64.708 7.57063 62.3183 7.43127 61.1897 8.74642C60.6145 9.43774 60.3129 10.3165 60.3423 11.2157L60.3342 13.8974V20.5774H54.3005V14.509L54.3167 11.0682C54.4309 8.74665 55.4008 6.54987 57.0389 4.90244C60.4517 1.46031 66.4503 1.25194 70.1227 4.75902L70.1173 4.76308ZM31.8566 2.16524L31.9769 2.77276V2.96218C35.3114 1.62809 39.223 2.2099 41.9074 4.89703C43.5169 6.50289 44.4846 8.64234 44.6282 10.9126L44.6471 14.8797V20.576H38.6134V11.0371C38.5712 10.2184 38.2268 9.44448 37.647 8.86549C36.3508 7.56928 33.9611 7.42992 32.8325 8.74507C32.2575 9.43705 31.956 10.3161 31.985 11.2157L31.9769 14.9596V20.5774H25.9432V2.16119L31.8566 2.16524ZM14.7814 2.16524C17.2617 2.16524 19.6404 3.15156 21.3943 4.90721C23.1481 6.66287 24.1334 9.04405 24.1334 11.5269V11.5851V20.5855H18.0997V19.5707C17.0184 20.4069 15.6262 20.8872 13.8772 20.8872C13.7907 20.8872 13.7056 20.8872 13.6204 20.8872H13.519H13.3649C8.27199 20.8872 4.91994 16.8105 4.82803 11.7393V11.5269C4.82803 9.04405 5.81332 6.66287 7.56715 4.90721C9.32098 3.15156 11.6997 2.16524 14.18 2.16524C14.2813 2.16524 14.3814 2.16524 14.4814 2.16524H14.6287H14.7814ZM86.8829 11.5229C86.8829 10.2935 87.1248 9.07611 87.5948 7.9403C88.0648 6.80449 88.7536 5.77247 89.622 4.90315C90.4904 4.03384 91.5214 3.34427 92.656 2.8738C93.7907 2.40333 95.0067 2.16119 96.2349 2.16119H96.8377C98.0659 2.16101 99.282 2.40303 100.417 2.87344C101.551 3.34384 102.582 4.03341 103.451 4.90276C104.319 5.7721 105.008 6.8042 105.478 7.94009C105.948 9.07598 106.19 10.2934 106.19 11.5229V11.581V20.5814H100.155V19.5667C99.0733 20.4028 97.6798 20.8832 95.9307 20.8832C95.8442 20.8832 95.7591 20.8832 95.6739 20.8832H95.5726H95.4185C90.3255 20.8832 86.9735 16.8065 86.8829 11.7353V11.5229ZM111.319 14.2398C111.975 14.24 112.617 14.4351 113.162 14.8002C113.708 15.1654 114.133 15.6843 114.384 16.2912C114.635 16.8982 114.7 17.5661 114.572 18.2103C114.444 18.8546 114.128 19.4463 113.664 19.9107C113.199 20.3752 112.608 20.6914 111.965 20.8194C111.321 20.9475 110.654 20.8816 110.048 20.6302C109.441 20.3787 108.923 19.953 108.559 19.4068C108.194 18.8605 107.999 18.2184 107.999 17.5615C107.999 16.6807 108.349 15.836 108.971 15.2131C109.593 14.5902 110.437 14.2401 111.316 14.2398H111.319Z"
                                      fill="#805FFF"/>
                            </svg>
                        </a>
                    </div>
                    <div class="collapse mobile-nav position-absolute" [ngClass]="{'show': showNav}">
                        <div class=" ">
                            <ul class="d-flex flex-column">
                                <li class="">
                                    <a class="" [routerLinkActive]="'active'"
                                       [routerLinkActiveOptions]="{ exact: true }"
                                       [routerLink]="[ '/']">
                                        {{'MENU.AI companion' | translate}}
                                    </a>
                                </li>
                                <li class="">
                                    <a class=""
                                       [routerLinkActive]="'active'"
                                       [routerLink]="['/tracker']"
                                       [routerLinkActiveOptions]="{ exact: true }">
                                        {{'MENU.Wellness Tracker' | translate}}
                                    </a>
                                </li>
                                <li class="">
                                    <a class="" [routerLinkActive]="'active'"
                                       href="https://blog.anima.help"
                                       target="_blank">
                                        {{'MENU.Insights' | translate}}
                                    </a>
                                </li>
                                <!--                    <li class="nav-item">-->
                                <!--                        <a class="nav-link" href="#plans">Plans</a>-->
                                <!--                    </li>-->
                                <li class="">
                                    <a class="" [routerLinkActive]="'active'"
                                       [routerLink]="['/for-business']">
                                        {{'MENU.For business' | translate}}</a>
                                </li>
                                <li class="">
                                    <a class="" [routerLinkActive]="'active'" [routerLink]="[ '/about-us']">
                                        {{'MENU.About' | translate}}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
            <div class="menu-items collapse navbar-collapse">
                <ul class="d-flex align-items-center pl-md-4 pr-2 m-0">

                    <li class="nav-item">
                        <a class="nav-link" [routerLinkActive]="'active'"
                           [routerLinkActiveOptions]="{ exact: true }"
                           [routerLink]="['/']">{{'MENU.AI companion' | translate}}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLinkActive]="'active'"
                           [routerLink]="['/tracker']"
                           [routerLinkActiveOptions]="{ exact: true }">{{'MENU.Wellness Tracker' | translate}}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLinkActive]="'active'" [routerLink]="[ '/pricing']"
                           [routerLinkActiveOptions]="{ exact: true }">{{'MENU.Pricing' | translate}}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLinkActive]="'active'" href="https://blog.anima.help"
                           target="_blank">{{'MENU.Insights' | translate}}</a>
                    </li>
                    <!--                    <li class="nav-item">-->
                    <!--                        <a class="nav-link" href="#plans">Plans</a>-->
                    <!--                    </li>-->
                    <li class="nav-item">
                        <a class="nav-link" [routerLinkActive]="'active'"
                           [routerLink]="[ '/for-business']">{{'MENU.For business' | translate}}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLinkActive]="'active'"
                           [routerLink]="[ '/about-us']">{{'MENU.About' | translate}}</a>
                    </li>
                </ul>
            </div>

            <div class="col d-flex position-sticky sticky-top align-items-center justify-content-end">
                <a class="btn_startTest hover_action" *ngIf="isForBusiness"
                   href="https://calendly.com/cooperation-anima/30min"
                   target="_blank">{{'global.Book a demo' | translate}}</a>


                <ng-container *ngIf="!isAiChat">
                    <button aria-label="Take a test" *ngIf="!isMobile && showAiStartTestButton || showStartTestButton"
                            class="btn_startTest hover_action" (click)="startTest()">
                        {{"global.Take a test" | translate}}
                        <svg aria-hidden="true" width="8" height="14" viewBox="0 0 8 14" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 13L7 7L1 1" stroke="white" stroke-width="1.5" stroke-linecap="round"
                                  stroke-linejoin="round"/>
                        </svg>
                    </button>
                </ng-container>
                <ng-container *ngIf="showAiStartTestButton || showStartTestButton">
                    <ng-container *ngIf="isAiChat">
                        <button aria-label="Take a test"
                                class="btn_startTest hover_action" (click)="startTest()">
                            <ng-container *ngIf="!payed.isPayed()">
                                {{"global.Try For Free" | translate}}
                            </ng-container>
                            <ng-container *ngIf="payed.isPayed()">
                                {{"global.Check in" | translate}}
                            </ng-container>
                            <svg aria-hidden="true" width="8" height="14" viewBox="0 0 8 14" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 13L7 7L1 1" stroke="white" stroke-width="1.5" stroke-linecap="round"
                                      stroke-linejoin="round"/>
                            </svg>

                        </button>

                    </ng-container>
                </ng-container>
                <div class="nav-logged_in select-language" ngbDropdown display="dynamic" placement="bottom-end">
                    <button class="user-menu text-uppercase"
                            id="dropdownUser2"
                            ngbDropdownToggle>
                        {{languageService.getCurrentLanguage()}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownUser2">
                        <button [ngClass]="{'active': languageService.getCurrentLanguage() === 'en'}"
                                [disabled]=" languageService.getCurrentLanguage() === 'en'"
                                class="dropdown-item text-uppercase" (click)="languageService.switchLanguage('en')">En
                        </button>
                        <button [ngClass]="{'active': languageService.getCurrentLanguage() === 'es'}"
                                [disabled]=" languageService.getCurrentLanguage() === 'es'"
                                class="dropdown-item text-uppercase" (click)="languageService.switchLanguage('es')">Es
                        </button>
<!--                        <button [ngClass]="{'active': languageService.getCurrentLanguage() === 'uk'}"-->
<!--                                [disabled]=" languageService.getCurrentLanguage() === 'uk'"-->
<!--                                class="dropdown-item text-uppercase" (click)="languageService.switchLanguage('uk')">Ук-->
<!--                        </button>-->

                    </div>
                </div>
                <div class="nav-log_in" *ngIf="!isLoggedIn">
                    <button aria-label="login" (click)="openAuthModal()">
                        <svg aria-hidden="true" width="32" height="32" viewBox="0 0 32 32" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M26.6667 28V25.3333C26.6667 23.9188 26.1048 22.5623 25.1046 21.5621C24.1044 20.5619 22.7478 20 21.3333 20H10.6667C9.25219 20 7.89563 20.5619 6.89544 21.5621C5.89525 22.5623 5.33334 23.9188 5.33334 25.3333V28"
                                  stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M16 14.6667C18.9455 14.6667 21.3333 12.2789 21.3333 9.33333C21.3333 6.38781 18.9455 4 16 4C13.0545 4 10.6667 6.38781 10.6667 9.33333C10.6667 12.2789 13.0545 14.6667 16 14.6667Z"
                                  stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
                <div class="nav-logged_in" *ngIf="isLoggedIn">
                    <div ngbDropdown display="dynamic" placement="bottom-end">
                        <button class="user-menu"
                                [ngClass]="{'text-muted': auth?.userData?.isAnonymous}"
                                id="dropdownUser"
                                ngbDropdownToggle>
                            <img class="thumb" alt="user thumbnail" [src]="auth?.userData?.photoURL"
                                 *ngIf="auth?.userData?.photoURL">
                            <div class="thumb d-flex align-items-center justify-content-center"
                                 *ngIf="!auth?.userData?.photoURL">
                                <img height="24" alt="user thumbnail"
                                     src="assets/icons/user.png">
                            </div>
                            <ng-container *ngIf="feature.isBeta">
                                <span class="beta-icon">beta</span>
                            </ng-container>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownUser">
                            <span class="dropdown-item-text ">
                                {{auth.userData?.displayName}}&nbsp;
                                <span class="leftovers"> - {{auth.userState?.leftover}}</span>
                                <span class="leftovers ml-auto"
                                      *ngIf="auth.userState?.subscription?.activated && auth.userState.report.count">({{auth.userState.report.count}}
                                    )
                                </span>
                            </span>

                            <a class="dropdown-item" [routerLink]="'/s/'+latestResultId+'/r'"
                               *ngIf="latestResultId" ngbDropdownItem>
                                {{'MENU.Dashboard' | translate}}
                            </a>
                            <a class="dropdown-item" [routerLink]="'/chat/'+latestResultId"
                               *ngIf="latestResultId && payed.isPayed()" ngbDropdownItem>
                                {{'MENU.AI companion' | translate}} 💬
                            </a>
                            <div class="dropdown-divider"></div>
                            <button (click)="onSignOut()" ngbDropdownItem>
                                {{'MENU.Log out' | translate}}
                            </button>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </header>
</section>
